


import GoogleMapFactory from './map-api/google/map-api-factory';
import GoogleMapMarkerFactory from './map-api/google/marker-api-factory';
import CollectionManagerFactory from './map-api/collection-manager-factory';

import LeafletMapFactory from './map-api/leaflet/map-api-factory';
import LeafletMarkerFactory from './map-api/leaflet/marker-api-factory';

// maps-factory reference, key is mapType
const mapsFactoryReference = {
  '1': GoogleMapFactory,
  '2': LeafletMapFactory
};

// marker-factory reference, key is mapType
const markerFactoryReference = {
  '1': GoogleMapMarkerFactory,
  '2': LeafletMarkerFactory
};





$(document).ready(function() {


  let outerMapDomEls = document.querySelectorAll('.js-multimaps-map-outer');

  // Use Array.prototype.slice.call as forEach on nodeList does
  // not work in IE11
  Array.prototype.slice.call(outerMapDomEls).forEach(function(outerMapEl){

    let mapDomEl = outerMapEl.querySelector('.js-multimaps-map'),
      markers = outerMapEl.querySelectorAll('.js-map-marker'),
      data = mapDomEl.dataset,
      MapFactory = mapsFactoryReference[data.type],
      MarkerFactory = markerFactoryReference[data.type],
      collectionManager,
      allMarkersCollection,
      mapHandler,
      mapObj,
      markerToOpen,
      markerToCenterOn;

    // Create map handler instance, passing
    // needed options
    mapHandler = MapFactory.create({data});

    // Create instance of collection manager
    collectionManager = CollectionManagerFactory.create();

    // Add new collection to manager
    allMarkersCollection = collectionManager.addCollection('markers');

    // Add map to DOM
    mapHandler.addMap();

    // get created map object
    mapObj = mapHandler.getMap();

    $(window).on('resize', () => {
      mapHandler.resize();
    });


    // Add markers
    Array.prototype.slice.call(markers).forEach(function(marker, x){
      let markerData = marker.dataset,
        markerContent = marker.innerHTML,
        markerHandler,
        categoryCollection,
        iconObj;

      // If icon options were passed as json string
      if (markerData.icon) {
        iconObj = JSON.parse(markerData.icon);
      };

      // Create marker handler
      markerHandler = MarkerFactory.create({
        data:{
          lat: markerData.lat,
          lng: markerData.lng,
          map: mapObj,
          icon: iconObj
        }, options: {}
      });

      // Add infowindow if needed
      if (markerContent) {
        markerHandler.addInfoWindow(markerContent);
      }

      // Example of using collection manager to add
      // collections based on marker categories
      if (markerData.catId) {
        if (!collectionManager.collectionExists('cat_' + markerData.catId)) {
          categoryCollection = collectionManager.addCollection('cat_' + markerData.catId);
        } else {
          categoryCollection = collectionManager.getCollection('cat_' + markerData.catId);
        }

        categoryCollection.addItem(markerData.id, markerHandler);
      }

      // Add all markers to non-categorised collection
      allMarkersCollection.addItem(markerData.id, markerHandler);

      // Should a specific marker window be open?
      if (markerData.openInfo) {
        markerToOpen = markerHandler;
      }

      // // Should map be centered on a specific marker?
      if (markerData.center) {
        markerToCenterOn = markerHandler;
      }
    });


    if (markerToOpen) {
      mapHandler.onReady(function openMarkerOnReady(){
        markerToOpen.openWindow();
      });
    }

    if (markerToCenterOn) {
      mapHandler.onReady(function centerOn(){
        mapHandler.setCenter(markerToCenterOn.data.lat, markerToCenterOn.data.lng);
      });
    } else if (data.autofit === '1') {
      // Should map bounds be autofitted to markers?
      mapHandler.onReady(function centerOn(){
        mapHandler.fitToItems(allMarkersCollection.getAllItems());
      });
    } else {
      mapHandler.setCenter(data.centerLat, data.centerLng);
    }

  });

});



// WEBPACK FOOTER //
// ./src/frontend/js/app.js